var _defs, _g, _path, _rect, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLiveRevalida(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-live-revalida",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 131.679,
    height: 85.078,
    viewBox: "0 0 131.679 85.078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 1.011,
    y2: 1.015,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#098caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09d785"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1866",
    "data-name": "Caminho 1866",
    d: "M114.875,0V7.515h-10.74V0H0V85.078H131.679V80.42H73.15V75.455h58.529V0Z",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5094",
    "data-name": "Grupo 5094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5093",
    "data-name": "Grupo 5093",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1695",
    "data-name": "Ret\\xE2ngulo 1695",
    width: 131.679,
    height: 85.078,
    fill: "url(#linear-gradient)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1867",
    "data-name": "Caminho 1867",
    d: "M51.487,115.414v-58.2h8.4v49.926H73.262v8.276Z",
    transform: "translate(-38.716 -43.021)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1696",
    "data-name": "Ret\\xE2ngulo 1696",
    width: 8.395,
    height: 58.203,
    transform: "translate(42.774 14.191)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1868",
    "data-name": "Caminho 1868",
    d: "M259.642,115.414h-11.51L242.2,77.8,239.47,57.212h8.484l5.9,44.853,5.933-44.853h8.484l-2.729,20.647Z",
    transform: "translate(-180.072 -43.021)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1869",
    "data-name": "Caminho 1869",
    d: "M388.176,57.211H409.95v8.276H396.571V82.159h11.51v8.306h-11.51v16.672H409.95v8.276H388.176Z",
    transform: "translate(-291.892 -43.02)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLiveRevalida);
export default __webpack_public_path__ + "static/media/logo-live-revalida.1ad4d62062a7b73ce8150738be35c175.svg";
export { ForwardRef as ReactComponent };